import { render, staticRenderFns } from "./Decades.vue?vue&type=template&id=1c9dd3e7&"
import script from "./Decades.vue?vue&type=script&lang=js&"
export * from "./Decades.vue?vue&type=script&lang=js&"
import style0 from "./Decades.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports